import { ModulesMap, ModulesConfigMap } from '@/config/data/modulesMaps'
import { _apiRequestWrap } from '../apiService'

function _getLogisticRoutesGeoZones(options = {}) {
	return _apiRequestWrap(
		ModulesMap.LOGISTIC_ROUTES_GEO_ZONES,
		ModulesConfigMap[ModulesMap.LOGISTIC_ROUTES_GEO_ZONES].GET_LOGISTIC_ROUTES_GEO_ZONES,
		options
	)
}

function _getLogisticRoutesGeoZonePreview(options = {}) {
	return _apiRequestWrap(
		ModulesMap.LOGISTIC_ROUTES_GEO_ZONES,
		ModulesConfigMap[ModulesMap.LOGISTIC_ROUTES_GEO_ZONES].GET_LOGISTIC_ROUTES_GEO_ZONE_PREVIEW,
		options
	)
}

function _getLogisticRoutesGeoZonePopup(options = {}) {
	return _apiRequestWrap(
		ModulesMap.LOGISTIC_ROUTES_GEO_ZONES,
		ModulesConfigMap[ModulesMap.LOGISTIC_ROUTES_GEO_ZONES].GET_LOGISTIC_ROUTES_GEO_ZONE_POPUP,
		options
	)
}

function _getLogisticRoutesGeoZone(options = {}) {
	return _apiRequestWrap(
		ModulesMap.LOGISTIC_ROUTES_GEO_ZONES,
		ModulesConfigMap[ModulesMap.LOGISTIC_ROUTES_GEO_ZONES].GET_LOGISTIC_ROUTES_GEO_ZONE,
		options
	)
}

function _createLogisticRoutesGeoZone(options = {}) {
	return _apiRequestWrap(
		ModulesMap.LOGISTIC_ROUTES_GEO_ZONES,
		ModulesConfigMap[ModulesMap.LOGISTIC_ROUTES_GEO_ZONES].CREATE_LOGISTIC_ROUTES_GEO_ZONE,
		options
	)
}

function _putLogisticRoutesGeoZone(options = {}) {
	return _apiRequestWrap(
		ModulesMap.LOGISTIC_ROUTES_GEO_ZONES,
		ModulesConfigMap[ModulesMap.LOGISTIC_ROUTES_GEO_ZONES].PUT_LOGISTIC_ROUTES_GEO_ZONE,
		options
	)
}

function _patchLogisticRoutesGeoZone(options = {}) {
	return _apiRequestWrap(
		ModulesMap.LOGISTIC_ROUTES_GEO_ZONES,
		ModulesConfigMap[ModulesMap.LOGISTIC_ROUTES_GEO_ZONES].PATCH_LOGISTIC_ROUTES_GEO_ZONE,
		options
	)
}

function _deleteLogisticRoutesGeoZone(options = {}) {
	return _apiRequestWrap(
		ModulesMap.LOGISTIC_ROUTES_GEO_ZONES,
		ModulesConfigMap[ModulesMap.LOGISTIC_ROUTES_GEO_ZONES].DELETE_LOGISTIC_ROUTES_GEO_ZONE,
		options
	)
}

export default {
	[ModulesConfigMap[ModulesMap.LOGISTIC_ROUTES_GEO_ZONES].GET_LOGISTIC_ROUTES_GEO_ZONES]: _getLogisticRoutesGeoZones,

	[ModulesConfigMap[ModulesMap.LOGISTIC_ROUTES_GEO_ZONES].GET_LOGISTIC_ROUTES_GEO_ZONE_PREVIEW]: _getLogisticRoutesGeoZonePreview,

	[ModulesConfigMap[ModulesMap.LOGISTIC_ROUTES_GEO_ZONES].GET_LOGISTIC_ROUTES_GEO_ZONE_POPUP]: _getLogisticRoutesGeoZonePopup,

	[ModulesConfigMap[ModulesMap.LOGISTIC_ROUTES_GEO_ZONES].GET_LOGISTIC_ROUTES_GEO_ZONE]: _getLogisticRoutesGeoZone,

	[ModulesConfigMap[ModulesMap.LOGISTIC_ROUTES_GEO_ZONES].CREATE_LOGISTIC_ROUTES_GEO_ZONE]: _createLogisticRoutesGeoZone,

	[ModulesConfigMap[ModulesMap.LOGISTIC_ROUTES_GEO_ZONES].PUT_LOGISTIC_ROUTES_GEO_ZONE]: _putLogisticRoutesGeoZone,

	[ModulesConfigMap[ModulesMap.LOGISTIC_ROUTES_GEO_ZONES].PATCH_LOGISTIC_ROUTES_GEO_ZONE]: _patchLogisticRoutesGeoZone,

	[ModulesConfigMap[ModulesMap.LOGISTIC_ROUTES_GEO_ZONES].DELETE_LOGISTIC_ROUTES_GEO_ZONE]: _deleteLogisticRoutesGeoZone,
}
